import { environment } from '../../../environments/environment';
const BASE_URL = `${environment.BASE_URL}/api/v1`;
export const ROUTES = {
  LOGIN: `${BASE_URL}/auth/signin`,
  INITIATE_PAYMENT: `${BASE_URL}/payment/initiate`,
  CANCEL_PAYMENT: `${BASE_URL}/payment/cancel`,
  VERIFY_PAYMENT: `${BASE_URL}/payment/verify/{gateway}`,
  GET_LAST_TRAN_BY_FC: `${BASE_URL}/members/transactions`,
  GET_LAST_TRAN_BY_FC_OCR_ID: `${BASE_URL}/members/transactions/ocrid`,
  MEMBER_DETAILS: `${BASE_URL}/members`,
  PENDING_FAMILY_CODES: `${BASE_URL}/members/pending`,
  DENOMINATOIN_PER_DAY_TOTAL_CASH: `${BASE_URL}/phil-meta-data/me/total-cash-entry`,
  DENOMINATOIN_PER_DAY_TOTAL_CASH_FOR_LOT: `${BASE_URL}/lot/total/cash/received`,
  SUBMIT_ARGHYA_DENOMINATION: `${BASE_URL}/phil-meta-data/daily-denomination`,
  UPDATE_PENDING_FAMILY_CODES: `${BASE_URL}/members/pending/update`,
  GRNERATE_FC: `${BASE_URL}/members/family/new`,
  GRNERATE_FC_BY_USER: `${BASE_URL}/members/family/new/user`,
  GET_PHIL_DEPOSIT_CODES: `${BASE_URL}/phil-meta-data/deposit-codes`,
  UPDATE_PHIL_DEPOSIT_CODES: `${BASE_URL}/phil-meta-data/deposit-codes/status`,
  GET_WORKER_BY_KEY: `${BASE_URL}/worker/all`,
  GET_BENIFICIARY_BY_KEY: `${BASE_URL}/worker/beneficiary/all`,
  CREATE_ENTRY: `${BASE_URL}/entries`,
  GET_OBJECT_SPECIFICATION: `${BASE_URL}/phil-meta-data/object/specifications`,
  GET_BY_PINCODE: `${BASE_URL}/geo-data/pincodes/{pin}`,
  GET_ALL_STATES: `${BASE_URL}/geo-data/states`,
  GET_ALL_DISTRICTS_BY_STATE: `${BASE_URL}/geo-data/{state}/districts`,
  GET_ADDR_BY_KEY: `${BASE_URL}/geo-data/addresses/{addr}`,
  GET_ALL_BANKS: `${BASE_URL}/phil-meta-data/bank-accounts`,
  SEND_OTP: `${BASE_URL}/phil-meta-data/otp/generate`,
  VERIFY_OTP: `${BASE_URL}/phil-meta-data/otp/verify`,
  GET_OCCURENCE_DETAILS: `${BASE_URL}/entries/details`,
  GET_OCCURENCE_DETAILS_ADMIN: `${BASE_URL}/entries/details/admin`,
  GET_ENTRY_DETAILS: `${BASE_URL}/entries`,
  UPDATE_MEMBER: `${BASE_URL}/members/update/details`,
  UPDATE_MEMBER_BY_ADMIN: `${BASE_URL}/members/update/details/admin`,
  UPDATE_DISCLAIMER_DETAILS: `${BASE_URL}/members/financial-year-details`,
  GET_ALL_ENTRY_DETAILS: `${BASE_URL}/entries/all`,
  REFRESH_PAYMENT: `${BASE_URL}/payment/refresh`,
  // USER_INFO: `${BASE_URL}/members/user/info`,
  // UPDATE_USER_CONTACT: `${BASE_URL}/members/change/user/contact`,
  GET_ALL_COUNTRY_CURRENCY: `${BASE_URL}/geo-data/countries`,
  UPDATE_REMITTER: `${BASE_URL}/members/remitter`,
  DELETE_MEMBER: `${BASE_URL}/members/inactive/mark`,
  GET_ALL_MUNICIPALITY_BY_STATE_DISTRICT: `${BASE_URL}/geo-data/{state}/{district}/municipality`,
  GET_SERVICE_CHARGE: `${BASE_URL}/payment/service/charge`,
  TRANSACTION_STATUS: `${BASE_URL}/payment/transaction/status`,
  GET_PAYMENT_MODES: `${BASE_URL}/phil-meta-data/payment-modes`,
  CREATE_LOT_RECEIVE: `${BASE_URL}/entries/lot/create`,
  RECEIVED_LOT_HISTORY: `${BASE_URL}/entries/lot/list`,
  GET_ALL_STATUSSSES: `${BASE_URL}/phil-meta-data/statuses`,
  EDIT_LOT_RECEIVE: `${BASE_URL}/entries/lot/edit`,
  LOT_PRINT: `${BASE_URL}/entries/lot/print`,
  GET_LOT_SUMMARY: `${BASE_URL}/entries/lot/summary`,
  CREATE_LOT_SE: `${BASE_URL}/entries/lot`,
  GET_WORKER: `${BASE_URL}/worker`,
  ADVANCED_SEARCH: `${BASE_URL}/members/master/search`,
  RECEIVED_HISTORY_ENTRIES: `${BASE_URL}/entries/lot/slips`,
  DELETE_SLIP_ENTRY: `${BASE_URL}/entries/{slip_id}`,
  GET_DEPOSIT_HISTORY: `${BASE_URL}/members/transactions/history`,
  GET_ENTRY_DETAILS_SELF: `${BASE_URL}/entries/self`,
  CONFIG: `${BASE_URL}/phil-meta-data/config`,
  UPDATE_PASSWORD: `${BASE_URL}/auth/update/password`,
  GET_ALL_CENTERS: `${BASE_URL}/phil-meta-data/centers`,
  ARGHYA_COUNTER_WISE: `${BASE_URL}/entries/arghya-stats/counterwise/report`,
  UNSETTLED_LOT_RECORDS: `${BASE_URL}/settlement/unsettled-lot-records`,
  USERS_LIST: `${BASE_URL}/users/list`,
  EDIT_IMAGE_IN_ABSTRACT_REPORT: `${BASE_URL}/lot/{lotId}`,
  MATCH_UNSETTLED: `${BASE_URL}/settlement/match-unsettled`,
  FETCH_BA_PAYMENT_MODES: `${BASE_URL}/phil-meta-data/bank-accounts/payment-modes`,
  UTSAV_ARGHA: `${BASE_URL}/entries/fiscal/utsav/arghya/details`,
  SETTLEMENT_LOTS_UPDATE_STATUS: `${BASE_URL}/settlement/lot-status/{lotid}`,
  SETTLEMENT_LOTS: `${BASE_URL}/settlement/lots/{lotid}`,
  UNSETTLED_BANK_RECORDS: `${BASE_URL}/settlement/unsettled-bank-records`,
  GET_LOT_REPORT_SUMMARY: `${BASE_URL}/lot/reports/summary`,
  UPDATE_CASH_REPORT: `${BASE_URL}/entries/report/cash-update`,
  FETCH_BANKACCOUNT_VIA_CENTER: `${BASE_URL}/phil-meta-data/centers/mycenter/deposit-bank-accounts`,
  UPLOAD_CASH_SLIPS: `${BASE_URL}/entries/cash-slips/{occurrenceId}`,
  GET_TRANSACTION_SUMMARY: `${BASE_URL}/entries/transaction/summary`,
  GET_MODE_WISE_SUMMARY: `${BASE_URL}/entries/transaction/mode/details`,
  GET_MODE_CASH_WISE_SUMMARY: `${BASE_URL}/phil-meta-data/total-cash-entry`,
  GET_HEAD_WISE_COUNTS: `${BASE_URL}/entries/transaction/head/details`,
  GET_ENTRY_STATS_REPORT: `${BASE_URL}/entries/effort/report`,
  GET_MISC_STATS: `${BASE_URL}/entries/misc/details`,
  GET_DENOMINATIONS_STATS: `${BASE_URL}/entries/denomination/summary`,
  GET_TOKEN_WISE_TRANSACTION: `${BASE_URL}/lot/report/token/transaction`,
  GET_BANK_WISE_TOKEN_AMOUNTS: `${BASE_URL}/lot/report/bank/summary`,
  GET_CASH_COUNTER_STAT_COUNT: `${BASE_URL}/entries/arghya-stats/report`,
  GET_LOT_BANKWISE_REPORT: `${BASE_URL}/lot/report/bank/summary`,
  CONSOLIDATED_LOT_RECEIVE_SUMMARY: `${BASE_URL}/lot/reports/consolidatedReceiveSummary`,
  ARGHYA_REPORT: `${BASE_URL}/entries/arghya-stats/counterwise/report`,
  GET_TRANSACTION_REPORT_SUMMARY: `${BASE_URL}/entries/arghya/entry-details`,
  GET_MAGAZINE_ORDER_DETAILS: `${BASE_URL}/magazine/order-details/magazine`,
  GET_MAGAZINE_PAYMENTMODE_WISE: `${BASE_URL}/magazine/order-details/payment`,
  GET_MAGAZINE_BANK_WISE: `${BASE_URL}/magazine/order-details/bank`,
  BANK_STATEMENT_SETTLEMENT_STATS: `${BASE_URL}/settlement/bank-statement-settlement-stats`,
  USER_EFFORT_STATS: `${BASE_URL}/settlement/user-effort-stats`,
  LOT_LIST_LITE: `${BASE_URL}/lot/list-lite`,
  DP_SP_RECEIVED_COUNTS: `${BASE_URL}/entries/fiscal/dsp/details`,
  ABSTRUCT_REPORT: `${BASE_URL}/entries/abstruct/report`,
  FULL_ABSTRUCT_REPORT: `${BASE_URL}/entries/abstruct/full/report`,
  VERIFY_ABSTRUCT_REPORT_DATA: `${BASE_URL}/entries/abstract/verify`,
  DP_RECEIVING_LIST: `${BASE_URL}/dp/list`,
  DP_RECEIVED_REPORT: `${BASE_URL}/dp/report/received`,
  DP_EFFORT_REPORT: `${BASE_URL}/dp/report/effort`,
  RECEIVED_LOT_STATS: `${BASE_URL}/settlement/received-lot-stats`,
  DATE_TO_DATE_TRANSACTION_REPORT: `${BASE_URL}/entries/date-to-date/report`,
  UPLOAD_INPUT_SLIPS: `${BASE_URL}/entries/upload/input/slips`,
  RITWICKI_WITHDRAWAL: `${BASE_URL}/payment/ritwicki/withdrawal`,
  FINANCIAL_YEARWISE_REPORT: `${BASE_URL}/entries/fiscal/transaction`,
  GET_RITWIKI_BALANCE: `${BASE_URL}/worker/ritwiki/balance`,
};
